module.exports = __webpack_public_path__ + "img/IMDC_noname.4675050e.png";